export enum CountryPL {
    POLAND = "Polska",
    SPAIN = "Hiszpania"
}
